<template>
  <span v-on:click="clicktolink">
    <slot></slot>
  </span>
</template>

<script>
    import i18n from '@/i18n';
    import Helper from '@/helper/Helper';
//    const {ipcRenderer} = require('electron');

    export default {
        name: 'BtnFullScren',
      data() {
        return {
          fullscreen: false
        };
      },
        props: {
            template: String,
            clear: String,
        },
        watch: {
          fullscreen: function (newData, oldData) {
            const modul = this;
            localStorage.setItem("fullscreen",newData)
//            if(newData){
//              localStorage.setItem("store")
//            } else {
//              localStorage.setItem("store")
//            }
          },
        },
        mounted() {
          const modul = this;
          if (localStorage) {
            modul.fullscreen = (localStorage.getItem("fullscreen")==="true");

          }
        },
        methods: {
            clicktolink(e){
                console.log("clicktolink");
                const modul = this;
              e.preventDefault();

              const elem = document.documentElement;

              /* View in fullscreen */
              function openFullscreen() {
                if (elem.requestFullscreen) {
                  elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                  elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                  elem.msRequestFullscreen();
                }
                modul.fullscreen = true;
              }
              function closeFullscreen() {
                if (document.exitFullscreen) {
                  document.exitFullscreen();
                } else if (document.webkitExitFullscreen) { /* Safari */
                  document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE11 */
                  document.msExitFullscreen();
                }
                modul.fullscreen = false;
              }
              if(!modul.fullscreen){
                openFullscreen();
              } else {
                closeFullscreen();
              }
//                ipcRenderer.send('fullscreen', 'ping');
            },
        }
    };
</script>

<style>
</style>

